/** Formata CPF (000.000.000-00) ou CNPJ (00.000.000/0000-00). */
export function formatarCpfCnpj(valor: string | null | undefined): string {
  if (!valor) return '';
  const num = valor.replace(/\D/g, '');
  if (num.length === 11) {
    return num.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
  if (num.length === 14) {
    return num.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }
  return valor;
}

/** Formata WhatsApp/telefone BR (+55 11 99999-0000). */
export function formatarTelefone(valor: string | null | undefined): string {
  if (!valor) return '';
  const num = valor.replace(/\D/g, '');
  if (num.length === 13 && num.startsWith('55')) {
    return `+55 ${num.slice(2, 4)} ${num.slice(4, 9)}-${num.slice(9)}`;
  }
  if (num.length === 11) {
    return `${num.slice(0, 2)} ${num.slice(2, 7)}-${num.slice(7)}`;
  }
  if (num.length === 10) {
    return `${num.slice(0, 2)} ${num.slice(2, 6)}-${num.slice(6)}`;
  }
  return valor;
}

/** Formata ISO timestamp -> DD/MM/YYYY. */
export function formatarData(valor: string | null | undefined): string {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return valor;
  return d.toLocaleDateString('pt-BR');
}

/** Formata ISO timestamp -> DD/MM/YYYY HH:mm. */
export function formatarDataHora(valor: string | null | undefined): string {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return valor;
  return `${d.toLocaleDateString('pt-BR')} ${d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}`;
}

/** "ha 3 dias", "ha 2 horas", "agora". */
export function tempoDecorrido(valor: string | null | undefined): string {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return valor;
  const diffMs = Date.now() - d.getTime();
  const seg = Math.floor(diffMs / 1000);
  if (seg < 60) return 'agora';
  const min = Math.floor(seg / 60);
  if (min < 60) return `ha ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `ha ${h} ${h === 1 ? 'hora' : 'horas'}`;
  const dias = Math.floor(h / 24);
  if (dias < 30) return `ha ${dias} ${dias === 1 ? 'dia' : 'dias'}`;
  const meses = Math.floor(dias / 30);
  if (meses < 12) return `ha ${meses} ${meses === 1 ? 'mês' : 'meses'}`;
  const anos = Math.floor(meses / 12);
  return `ha ${anos} ${anos === 1 ? 'ano' : 'anos'}`;
}
